@if (form) {
  <form [formGroup]="form">
    <p-panel class="mb-4" header="Enter new Provider information" [toggleable]="true" toggler="header">
      <div class="grid grid-cols-12 gap-4 p-fluid p-form-widget">
        <div class="col-span-12 md:col-span-6">
          <div class="field">
            <label>First Name:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="firstName"[required]="isExternalUser" />
            </div>
          </div>
          <div class="field">
            <label>Last Name:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="lastName"[required]="isExternalUser" />
            </div>
          </div>
          <div class="field">
            <label>NPI:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="practiceNpinumber" [required]="isExternalUser" />
            </div>
          </div>
        </div>
        <div class="col-span-12 md:col-span-6">
          <div class="field">
            <label>Street:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="physicalStreet"[required]="isExternalUser" />
            </div>
          </div>
          <div class="field">
            <label>City:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="physicalCity"[required]="isExternalUser" />
            </div>
          </div>
          <div class="field">
            <label>State:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="physicalState"[required]="isExternalUser" />
            </div>
          </div>
          <div class="field">
            <label>ZIP Code:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="physicalZip"[required]="isExternalUser" />
            </div>
          </div>
          <div class="field">
            <label>Phone:</label>
            <div class="p-field-value">
              <p-input-mask
                mask="(999) 999-9999"
                formControlName="phone"
                [unmask]="false"
                [autoClear]="false"
              ></p-input-mask>
            </div>
          </div>
        </div>
      </div>
    </p-panel>
  </form>
}
